export const data = [
  {
    id: "0",
    name: "VocApp",
    gif: "vocapp",
    link: "https://vocapp-beta.vercel.app/",
    codes: "https://github.com/aliaydogdu105/vocapp",
  },
  {
    id: "1",
    name: "Ask or Answer",
    gif: "ask-or-answer",
    link: "https://ask-or-answer-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/ask-or-answer_react",
  },
  {
    id: "2",
    name: "Movie App",
    gif: "movie-app",
    link: "https://movie-app-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/movie-app_react",
  },
  {
    id: "3",
    name: "Recipe App",
    gif: "recipe-app",
    link: "https://recipe-app-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/recipe-app_react",
  },
  {
    id: "4",
    name: "Task Tracker",
    gif: "task-tracker",
    link: "https://task-tracker-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/task-tracker-app_react",
  },
  {
    id: "5",
    name: "Language Cards",
    gif: "language-cards",
    link: "https://language-cards-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/language-cards_react",
  },
  {
    id: "6",
    name: "Tour Places",
    gif: "tour-places",
    link: "https://tour-places-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/tour-places_react",
  },
  {
    id: "7",
    name: "Pokemon Cards",
    gif: "pokemon-cards",
    link: "https://github.com/aliaydogdu105/pokemon-cards_react",
    codes: "https://github.com/aliaydogdu105/pokemon-cards_react",
  },
  {
    id: "8",
    name: "Finance App",
    gif: "finance-app",
    link: "https://finance-app-react.netlify.app/",
    codes: "https://github.com/aliaydogdu105/finance-app_react",
  },
  {
    id: "9",
    name: "Space Tourism",
    gif: "space-tourism",
    link: "https://space-tourism-react-ali.netlify.app/",
    codes: "https://github.com/aliaydogdu105/space-tourism",
  },
];
